module.exports = __webpack_public_path__ + "img/Boy_030009.332fa4f9.png";